import { Spinner } from "react-bootstrap";

const Spin = ({ size = "sm" }) => {
  return (
    <>
      <Spinner animation="border" role="status" size={size}></Spinner>
    </>
  );
};

export default Spin;
